"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Tag_1 = require("./components/Tag");
var Tags = function (_a) {
    var data = _a.data, propEvents = _a.events, propOptions = _a.options, tagsType = _a.tagsType, propsTestId = _a.testId, overrideRemovableAccessibility = _a.overrideRemovableAccessibility, tagsGroupAriaLabel = _a.tagsGroupAriaLabel;
    var _b = __read(React.useState({
        hideFocus: true,
        removedArr: [],
        selectedArr: propOptions && propOptions.defaultSelected ? propOptions.defaultSelected : [],
    }), 2), state = _b[0], setState = _b[1];
    var setHideFocus = function (value) { return setState(__assign(__assign({}, state), { hideFocus: value })); };
    var removedArr = state.removedArr, selectedArr = state.selectedArr;
    var guid = function () { return "" + S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4(); };
    var S4 = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    var uniqueId = guid();
    var updatedDataArr = data;
    var removalHandledExternally = propOptions && propOptions.isHandledExternally ? propOptions.isHandledExternally : false;
    return (React.createElement("div", { "aria-live": "polite", "aria-label": tagsGroupAriaLabel ? tagsGroupAriaLabel : undefined, className: "flex flex-wrap" + (propOptions && propOptions.className ? " " + propOptions.className : "") + " ", "data-testid": propsTestId, role: tagsType === "default" ? undefined : "group" }, updatedDataArr.map(function (item, index) {
        var children = item.children, events = item.events, options = item.options, testId = item.testId;
        var loc = selectedArr.indexOf(index);
        var isSelected = loc !== -1;
        var realOptions = __assign(__assign({}, options), { tagsType: tagsType });
        var onClick = function () {
            if (tagsType === "default") {
                isSelected
                    ? setState(__assign(__assign({}, state), { selectedArr: selectedArr
                            .slice(0, loc)
                            .concat(selectedArr.slice(loc + 1, selectedArr.length)) }))
                    : setState(__assign(__assign({}, state), { selectedArr: selectedArr.concat([index]) }));
            }
            else {
                setState(__assign(__assign({}, state), { removedArr: removedArr.concat([index]) }));
                if (!removalHandledExternally) {
                    data.splice(index, 1);
                }
            }
            if (propEvents && propEvents.onClick) {
                propEvents.onClick(children);
            }
            if (events && events.onClick) {
                events.onClick(true);
            }
        };
        var realEvents = __assign(__assign({}, events), { onClick: onClick });
        return (React.createElement(Tag_1.default, { events: realEvents, hideFocus: state.hideFocus, isHandledExternally: propOptions && propOptions.isHandledExternally === true, key: index, options: realOptions, isLast: index + 1 === data.length, setHideFocus: setHideFocus, tagsType: tagsType, testId: tagsType === "removable" ? uniqueId + "-" + index : testId, total: data.length, overrideRemovableAccessibility: overrideRemovableAccessibility }, children));
    })));
};
exports.default = Tags;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Tags/Tags.js
// module id = 1787
// module chunks = 8